export function scrollToTop() {
	window.scrollTo(0, 0)
	document.documentElement.scrollTop = 0
	document.body.scrollTop = 0
}